import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Vpn, VpnData, VpnListData } from '../../models/vpn';
import { Paging } from '../../models/paging';
import { BooleanResp } from '../../models/boolean-resp';

@Injectable({
	providedIn: 'root'
})
export class VpnService {
	private _url: string = `${environment.baseAPI}/vpn`;

	constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }

	GETVPNs(paging:Paging){
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}${paging.getQs()}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: VpnListData = jsonConvert.deserializeObject(res, VpnListData);
                            if (response.success) {
                            	return response.data;
                            } else {
                            	this._httpUtils.handleError(response);
                                return
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	GETVPN(vpn_uuid: string):Observable<Vpn>{
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/${vpn_uuid}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: VpnData = jsonConvert.deserializeObject(res, VpnData);
                            if (response.success) {
                            	return response.data;
                            } else {
                            	this._httpUtils.handleError(response);
                                return new Vpn();
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	POSTVPN(body: Vpn){
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}`, JSON.stringify(body.dto()),{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}

	PUTVPN(body: Vpn, vpn_uuid:string){
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/${vpn_uuid}`, JSON.stringify(body.dto()),{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}


	DELETEVPN(vpn_uuid:string){
		try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/${vpn_uuid}`,{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            return res;
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
	}
}
